import { render, staticRenderFns } from "./ApplicantCrime.vue?vue&type=template&id=4b98c690&scoped=true&"
import script from "./ApplicantCrime.vue?vue&type=script&lang=js&"
export * from "./ApplicantCrime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98c690",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b98c690')) {
      api.createRecord('4b98c690', component.options)
    } else {
      api.reload('4b98c690', component.options)
    }
    module.hot.accept("./ApplicantCrime.vue?vue&type=template&id=4b98c690&scoped=true&", function () {
      api.rerender('4b98c690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/ApplicantCrime.vue"
export default component.exports